import { render, staticRenderFns } from "./parentpage.vue?vue&type=template&id=f1f72268&scoped=true&"
import script from "./parentpage.vue?vue&type=script&lang=js&"
export * from "./parentpage.vue?vue&type=script&lang=js&"
import style0 from "./parentpage.vue?vue&type=style&index=0&id=f1f72268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f72268",
  null
  
)

export default component.exports